import { instance } from '@src/configs/axios'
const fileService = {
  uploadFile: (params) => {
    return instance.post(`/api/admin/upload`, params)
  },
}

export default fileService
